<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
// import PageHeader from "@/components/page-header";

import {
  getOrganizationAccounts,
  createOrganizationAccount,
  patchOrganizationAccount,
  deleteOrganizationAccount,
} from "@/service";
import CustomerSelect from "@/views/work-order/components/widgets/customer-select";
import ServiceCompanySelect from "@/views/work-order/components/widgets/service-company-select";

import _ from 'lodash';
import tableLoading from "@/views/widgets/table-loading";
import {alertComfirm, successMsg} from "@/helpers/swal";
// import { USER_OBJECT_TYPE } from "@/config/common";
// import { getOptionLabel } from "@/helpers/common";
import {getCustomers, getCompany} from "@/helpers/common-service";
import {useVuelidate} from "@vuelidate/core";
import {required} from "@vuelidate/validators";


export default {
  setup: () => ({ v$: useVuelidate() }),
  page: {
    title: "账号管理",
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      title: '账号管理',
      items: [{
        text: "系统管理",
        href: "/",
      },
        {
          text: '组织管理',
          active: false,
        },
        {
          text: '账号管理',
          active: true,
        },
      ],
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      config: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      date2: null,
      tableHeaders: [
        {
          name: 'username',
          label: '账号',
          visible: true
        },
        {
          name: 'type',
          label: '类型',
          visible: true
        },
        {
          name: 'organization',
          label: '组织名称',
          visible: true
        },
        {
          name: 'name',
          label: '姓名',
          visible: true
        },
        {
          name: 'tel',
          label: '联系电话',
          visible: true
        },
        {
          name: 'status',
          label: '状态',
          visible: true
        },
      ],
      tableLoading: false,
      tableLoaded: false,
      dataList: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 10,
        keyword: '',
        type: null,
        status: null,
      },
      filter_value: {
        keyword: '',
        type: null,
        status: null,
      },
      adding: false,
      editId: null,
      editIndex: null,
      addItem: {
        user: {
          email: null,
          username: null,
          first_name: null,
          last_name: null,
          tel: null,
        },
        object_id: null,
        object_type: null,
        belong_id: null,
        belong_type: null,
      },
      editItem: {},
      customers: [],
      serviceCompany: [],
      objectTypeOptions: [
        { value: 'customer', label: '客户' },
        { value: 'service_company', label: this.$t('page.service-company') },
      ],
      statusOptions: [
        { value: true, label: '正常' },
        { value: false, label: '冻结' },
      ]
    };
  },
  validations: {
    addItem: {
      object_id: { required },
      object_type: { required },
      user: {
        first_name: { required },
        last_name: { required },
        tel: { required },
      }
    },
    editItem: {
      user: {
        first_name: { required },
        last_name: { required },
        tel: { required },
      }
    },
  },
  components: {
    Layout,
    // PageHeader,
    Multiselect,
    tableLoading,
    CustomerSelect,
    ServiceCompanySelect,
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    getCustomers().then(res => {
      this.customers = res
      getCompany().then(res2 => {
        this.serviceCompany = res2
        this._getFirstPage()
      })
    })
  },

  methods: {

    // 新建
    add() {
      for (let p in this.addItem) {
        if (p === 'user') {
          for (let k in this.addItem.user) {
            this.addItem.user[k] = null
          }
        } else {
          this.addItem[p] = null
        }
      }
      this.adding = true
    },
    // 保存添加
    addSave() {
      this.v$.addItem.$touch()
      if (this.v$.addItem.$invalid) {
        return
      }
      const params = _.cloneDeep(this.addItem)
      params.user.username = params.user.email
      params.belong_id = params.object_id
      params.belong_type = params.object_type
      params.kc_account_id = new Date().getTime()
      params.profile = {tel: params.user.tel}
      createOrganizationAccount(params).then(() => {
        successMsg('添加成功')
        this._getFirstPage()
        this.adding = false
      }).catch(err => {
        console.log(err)
      })
    },
    // 冻结
    lock(item) {
      let is_active = !item.user.is_active
      alertComfirm('确定执行此操作？',is_active ? '解冻账号' : '冻结账号').then(res => {
        if (res) {
          patchOrganizationAccount({
            id: item.id,
            user: {
              is_active: is_active
            }
          }).then(() => {
            this._getFirstPage()
            successMsg(this.$t("base.operate_success"))
          })
        }
      })
    },
    // 编辑
    edit(item, index) {
      this.editItem = Object.assign({}, item)
      this.editItem.user.tel = this.editItem.user.user_profile.tel
      this.editId = item.id
      this.editIndex = index
    },
    // 取消编辑
    editCancel() {
      this.editItem = {}
      this.editId = null
      this.editIndex = null
    },
    // 保存编辑
    editSave() {
      this.v$.editItem.$touch()
      if (this.v$.editItem.$invalid) {
        return
      }
      // const params = _.cloneDeep(this.editItem)
      // 不让 修改邮箱、用户名、类型、公司
      // params.user.username = params.user.email
      // params.belong_id = params.object_id
      // params.belong_type = params.object_type
      // params.kc_account_id = new Date().getTime()
      const params = {
        id: this.editItem.id,
        user: {
          first_name: this.editItem.user.first_name,
          last_name: this.editItem.user.last_name,
        },
        profile: {
          tel: this.editItem.user.tel,
        }
      }
      patchOrganizationAccount(params).then((res) => {
        successMsg('修改成功')
        this.dataList[this.editIndex] = res.payload
        this.editId = null
        this.editIndex = null
        this.editItem = {}
      }).catch(err => {
        console.log(err)
      })
    },
    // 客户选择后
    customerSelected(val) {
      if (this.adding) {
        this.addItem.object_id = val.id
      } else if (this.editId) {
        this.editItem.object_id = val.id
      }
    },
    // 服务商选择后
    serviceCompanySelected(val) {
      if (this.adding) {
        this.addItem.object_id = val
      } else if (this.editId) {
        this.editItem.object_id = val
      }
    },

    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 筛选
    doFilter () {
      this.orders = []
      const search = {
        keyword: null,
        type: null,
        status: null,
      }
      if (this.filter_value.keyword) {
        search['keyword'] = this.filter_value.keyword
      }
      if (this.filter_value.type) {
        search['object_type'] = this.filter_value.type
      }
      if (this.filter_value.status !== null) {
        search['status'] = this.filter_value.status
      }
      this.filters = _.assign(this.filters, search)
      this._getFirstPage()
    },
    // 重置
    resetSearch() {
      this.filter_value.keyword = null
      this.filter_value.type = null
      this.filter_value.status = null
      this.doFilter()
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val
      this._getList()
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val
      this._getFirstPage()
    },
    // 获取数据
    _getFirstPage() {
      this.filters.page = 1;
      this._getList()
    },
    _getList() {
      this.filters.page_size = this.perPage
      this.tableLoading = true
      this.tableLoaded = false
      getOrganizationAccounts(this.filters).then(res => {
        this.tableLoading = false
        this.tableLoaded = true
        this.dataList = res.payload.results
        this.count = res.payload.count
        this.setPages()
      }).catch(err => {
        console.log(err)
      })
    },
    deleteItem(id) {
      alertComfirm().then(res => {
        if (res) {
          deleteOrganizationAccount(id).then(res => {
            if (res.meta.code == 200) {
              successMsg(this.$t('base.delete_success'))
              this._getFirstPage()
            }
          })
        }
      })
    },
    getFieldText(item, fieldName) {
        let val = ''
        switch (fieldName) {
          case 'username':
            val = _.get(item, 'user.username', '')
            break;
          case 'type':
            val = item.object_type_txt
            break;
          case 'organization':
            val = _.get(item, 'object_txt', '')
            // if (item.object_type === 'customer') {
            //   const obj = _.find(this.customers, ['id', item.object_id])
            //   if (obj) {
            //     val = obj.name
            //   }
            // } else if (item.object_type === 'service_company') {
            //   const obj = _.find(this.serviceCompany, ['id', item.object_id])
            //   if (obj) {
            //     val = obj.name
            //   }
            // } else {
            //   val = ''
            // }
            break;
          case 'name':
            val = _.get(item, 'user.first_name', '') + ' ' + _.get(item, 'user.last_name', '')
            break;
          case 'tel':
            val = _.get(item, 'user.user_profile.tel', '')
            break;
          case 'status':
            val = _.get(item, 'user.is_active')
            break;
        }
        return val
    }

  },
};
</script>

<template>
  <Layout>
<!--    <PageHeader :title="title" :items="items" />-->
    <b-row>
      <b-col lg="12">
        <b-card no-body id="orderList">
          <b-card-header class="border-0">
            <b-row class="align-items-center gy-3">
              <b-col cols="sm">
                <h5 class="card-title mb-0">账号信息</h5>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex gap-1 flex-wrap">

                  <b-button type="button" variant="primary" class="add-btn" @click="add">
                    <i class="ri-add-line align-bottom me-1"></i> 添加
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="border border-dashed border-end-0 border-start-0 mb-3">
            <b-form>
              <b-row class="g-3">
                <b-col xxl="5" sm="6">
                  <div class="search-box">
                    <input type="text" class="form-control search" v-model="filter_value.keyword"
                           placeholder="账号/姓名/联系电话/电子邮箱" />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </b-col>
                <b-col xxl="2" sm="4">
                  <div class="input-light">
                    <Multiselect class="form-control" placeholder="选择类型" v-model="filter_value.type" :close-on-select="true" :searchable="false"
                                 :create-option="false" :options="objectTypeOptions" :can-clear="false" />
                  </div>
                </b-col>
                <b-col xxl="2" sm="4">
                  <div class="input-light">
                    <Multiselect class="form-control" placeholder="选择状态" v-model="filter_value.status" :close-on-select="true" :searchable="false"
                                 :create-option="false" :options="statusOptions" :can-clear="false" />
                  </div>
                </b-col>
                <b-col>
                  <div>
                    <b-button type="button" variant="success" class="me-2" @click="doFilter">
                      <i class="ri-equalizer-fill me-1 align-bottom"></i>
                      筛选
                    </b-button>
                    <b-button
                        type="button"
                        variant="info"
                        @click="resetSearch"
                    >
                      <i class="ri-restart-line me-1 align-bottom"></i>
                      重置
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <b-card-body class="pt-0">
            <div>
              <div class="table-responsive table-card mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                  <tr class="text-uppercase">
                    <template v-for="(item, index) in tableHeaders" :key="index">
                      <th v-show="item.visible">{{ item.label }}</th>
                    </template>
                    <th class="text-end" style="padding-right: 70px;">
                      操作
                    </th>
                  </tr>
                  </thead>
                  <tbody class="list form-check-all">
                    <tr v-if="adding">
                      <td>
                        <input type="text" class="form-control" v-model="addItem.user.email" />
                      </td>
                      <td class="td-min-w">
                        <Multiselect
                            class="form-control"
                            :class="v$.addItem.object_type.$errors.length ? 'is-invalid' : ''"
                            v-model="addItem.object_type"
                            :close-on-select="true"
                            :searchable="false"
                            :create-option="false"
                            :options="objectTypeOptions"
                            :can-clear="false"
                        />
                      </td>
                      <td  class="td-min-w">
                        <Multiselect v-if="!addItem.object_type" class="form-control" placeholder="组织机构" disabled/>
                        <customer-select v-else-if="addItem.object_type == 'customer'" :is-invalid="!!v$.addItem.object_id.$errors.length" @changed="customerSelected"></customer-select>
                        <service-company-select v-else :is-invalid="!!v$.addItem.object_id.$errors.length" @changed="serviceCompanySelected"></service-company-select>
                      </td>
                      <td class="td-min-w">
                        <div class="d-flex justify-content-between">
                          <input type="text" class="form-control me-2" :class="v$.addItem.user.first_name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('also.last name')" v-model="addItem.user.first_name" />
                          <input type="text" class="form-control me-2" :class="v$.addItem.user.last_name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('also.first name')" v-model="addItem.user.last_name" />
                        </div>
                      </td>
                      <td>
                        <input type="text" class="form-control" :class="v$.addItem.user.tel.$errors.length ? 'is-invalid' : ''" placeholder="" v-model="addItem.user.tel" />
                      </td>
                      <td></td>
                      <td class="text-end">
                        <i class="ri-checkbox-circle-line me-3 text-primary fs-2 cursor-pointer" @click="addSave"></i>
                        <i class="ri-close-circle-line me-3 text-danger fs-2 cursor-pointer" @click="adding = false"></i>
                      </td>
                    </tr>
                    <tr v-for="(item, index) in dataList" :key="index">
                      <template v-for="(titleItem, titleIdx) in tableHeaders" :key="titleIdx">
                        <td v-show="titleItem.visible"  :class="['type','organization','name'].includes(titleItem.name) ? 'td-min-w' : ''">

                          <!--        显示            -->
                          <template v-if="editId != item.id">
                            <template v-if="titleItem.name === 'status'">
                              <span v-if="getFieldText(item, 'status')" class="badge badge-soft-success">正常</span>
                              <span v-else class="badge badge-soft-danger">已冻结</span>
                            </template>
                            <span v-else>{{ getFieldText(item, titleItem.name) }}</span>
                          </template>
                          <!--         编辑           -->
                          <template v-else>
                            <Multiselect
                                v-if="titleItem.name == 'type'"
                                class="form-control"
                                v-model="editItem.object_type"
                                :close-on-select="true"
                                :searchable="false"
                                :create-option="false"
                                :options="objectTypeOptions"
                                :can-clear="false"
                                disabled
                            />
                            <div v-if="titleItem.name == 'organization'">
                              <customer-select :is-disabled="true" v-if="editItem.object_type == 'customer'" :selected-customer-id="editItem.object_id" @changed="customerSelected"></customer-select>
                              <service-company-select :is-disabled="true" v-else :selected-service-company="editItem.object_id" @changed="serviceCompanySelected"></service-company-select>
                            </div>
                            <div v-if="titleItem.name == 'name'" class="d-flex justify-content-between">
                              <input type="text" class="form-control me-2" :class="v$.editItem.user.first_name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('also.last name')" v-model="editItem.user.first_name" />
                              <input type="text" class="form-control me-2" :class="v$.editItem.user.last_name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('also.first name')" v-model="editItem.user.last_name" />
                            </div>
                            <input v-if="titleItem.name == 'username'" type="text" class="form-control" placeholder="" v-model="editItem.user.username" disabled />
                            <input v-if="titleItem.name == 'tel'" :class="v$.editItem.user.tel.$errors.length ? 'is-invalid' : ''" type="text" class="form-control" placeholder="" v-model="editItem.user.tel" />
                          </template>
                        </td>
                      </template>
                      <!--          操作          -->
                      <td class="text-end" v-if="editId != item.id">
                        <i class="ri-edit-2-line fs-3 text-primary me-3 cursor-pointer" @click="edit(item, index)"></i>
                        <i class="ri-lock-line fs-3 text-primary me-3 cursor-pointer" v-if="item.user.is_active" @click="lock(item, index)"></i>
                        <i class="ri-lock-unlock-line fs-3 text-primary me-3 cursor-pointer" v-if="!item.user.is_active" @click="lock(item, index)"></i>
                        <i class="ri-key-2-line fs-3 text-primary me-3 cursor-pointer"></i>

<!--                        <i class="ri-delete-bin-line fs-3 text-primary me-3 cursor-pointer" @click="deleteItem(item.id)"></i>-->
                      </td>
                      <td class="text-end" v-else>
                        <i class="ri-checkbox-circle-line me-3 text-primary fs-2 cursor-pointer" @click="editSave"></i>
                        <i class="ri-close-circle-line me-3 text-danger fs-2 cursor-pointer" @click="editCancel"></i>
                      </td>

                    </tr>
                  </tbody>
                </table>
                <table-loading :count="count" :table-loaded="tableLoaded" :table-loading="tableLoading"></table-loading>
              </div>

            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <Pagination
        v-if="tab_info_length"
        v-model:page="page"
        v-model:perPage="perPage"
        :pages="pages"
        :prePageOption="prePageOption"
        :tab_info_length="tab_info_length"
        @update:page="pageChange"
        @update:perPage="pageSizeChange"
        class="me-5 my-3"
    ></Pagination>
  </Layout>

</template>
<style scoped>
.td-min-w {
  min-width: 220px;
}
</style>
